import React from 'react';
import { Link } from 'react-router-dom';
import heroMockup from '../assets/images/vykon-hero-mockup.png';
import dashboardMockup from '../assets/images/vykon-dashboard.png';
import './Home.css';
import './Web.css'; // Reusing some web layout classes
import './Vykon.css';

function Vykon() {
    return (
        <div className="vykon-page">
            <section className="web-section bg-white" style={{ alignItems: 'center' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '24px', alignItems: 'flex-start' }}>
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>VÝKON
                    </div>
                    <h1 className="hp-h1">Marketing je potřeba řídit, ne jen spouštět.</h1>
                    <p className="hp-sub" style={{ maxWidth: '640px' }}>
                        Kampaně bez systému jsou jen výdaj. Pomáhám firmám nastavit měřitelný marketingový systém — a průběžně ho řídit tak, aby přinášel výsledky.
                    </p>
                    <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ marginTop: '16px' }}>
                        Probrat výkon
                    </a>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <img src={heroMockup} alt="Výkon dashboard mockup" className="vk-hero-mockup" />
                </div>
            </section>

            <section className="web-section bg-gray">
                <div className="vk-pb-left">
                    <div className="hp-badge hp-badge-blue">
                        <span className="dot"></span>PROBLÉM
                    </div>
                    <h2 className="hp-h2" style={{ fontSize: '36px' }}>Výkon se ztrácí, pokud:</h2>
                </div>
                <div className="vk-pb-right">
                    <div className="vk-pb-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="vk-pb-text">Rozpočet na kampaně jde ven, ale nikdo nesleduje, co přináší zpět.</p></div>
                    <div className="vk-pb-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="vk-pb-text">KPI nejsou jasně definované — každý reportuje jinak.</p></div>
                    <div className="vk-pb-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="vk-pb-text">Měření nefunguje — rozhodnutí se dělají na dojmu, ne na datech.</p></div>
                    <div className="vk-pb-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="vk-pb-text">Kampaně se spustí, ale nikdo je systematicky nevyhodnocuje.</p></div>
                    <div className="vk-pb-card"><span className="hp-badge-blue dot" style={{ marginTop: '6px', display: 'inline-block' }}></span><p className="vk-pb-text">Web a kampaně fungují odděleně — ne jako jeden systém.</p></div>
                </div>
            </section>

            <section className="web-section bg-white">
                <div className="audit-left">
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>AUDIT VÝKONU</div>
                    <h2 className="hp-h2" style={{ fontSize: '36px' }}>Začínáme analýzou, ne odhadem.</h2>
                    <p className="hp-sub">
                        Audit výkonu je vstupní fáze spolupráce. Projdu vaši analytiku, kampaně a funnel — a ukáži, co brzdí výsledky a kde je největší příležitost.
                    </p>
                    <div className="audit-list">
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Kontrola měření a datové vrstvy</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Analýza kampaní (PPC, SEO, sociální sítě)</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Kontrola funnelu a konverzní cesty</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Identifikace slabých míst a příležitostí</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Prioritizovaný akční plán</p></div>
                    </div>
                    <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ alignSelf: 'flex-start', marginTop: '16px' }}>
                        Objednat audit
                    </a>
                </div>
                <div className="audit-right">
                    <div className="hp-label" style={{ letterSpacing: '2px', fontSize: '11px', fontWeight: '600' }}>VÝSTUP AUDITU</div>
                    <h3 className="audit-r-title">Strukturovaný audit dokument</h3>
                    <p className="audit-r-desc">Kompletní přehled stavu marketingu, identifikované problémy a konkrétní doporučení.</p>

                    <div className="audit-r-div"></div>

                    <h3 className="audit-r-title">Prioritizovaný akční plán</h3>
                    <p className="audit-r-desc">Seřazené kroky podle dopadu a realizovatelnosti — co udělat jako první.</p>
                </div>
            </section>

            <section className="web-section bg-gray web-section-col">
                <div className="gain-header">
                    <div className="hp-badge hp-badge-blue"><span className="dot"></span>DLOUHODOBÁ SPOLUPRÁCE</div>
                    <h2 className="hp-h2">Audit je začátek. Řízení je kontinuita.</h2>
                    <p className="hp-sub" style={{ maxWidth: '700px' }}>Po auditu lze pokračovat průběžnou spoluprací. Řídím marketingový systém, koordinuji specialisty a hlídám, aby výkon šel správným směrem.</p>
                </div>
                <div className="mgmt-grid">
                    <div className="step-card">
                        <div className="step-num">01</div>
                        <h3 className="step-title" style={{ fontSize: '20px' }}>Nastavení KPI</h3>
                        <p className="step-desc">Jasné metriky a cíle pro každý kanál.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">02</div>
                        <h3 className="step-title" style={{ fontSize: '20px' }}>Pravidelné vyhodnocování</h3>
                        <p className="step-desc">Měsíční analýza dat a korekce strategie.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">03</div>
                        <h3 className="step-title" style={{ fontSize: '20px' }}>Optimalizace kampaní</h3>
                        <p className="step-desc">PPC, SEO, SoMe — každý kanál průběžně ladím.</p>
                    </div>
                    <div className="step-card">
                        <div className="step-num">04</div>
                        <h3 className="step-title" style={{ fontSize: '20px' }}>Koordinace specialistů</h3>
                        <p className="step-desc">Zapojuji ověřené partnery — PPC, obsah, UX, vývoj.</p>
                    </div>
                </div>
            </section>

            <section className="web-section bg-white" style={{ alignItems: 'center' }}>
                <div className="rep-left">
                    <div className="hp-badge hp-badge-blue" style={{ alignSelf: 'flex-start' }}>
                        <span className="dot"></span>REPORTING
                    </div>
                    <h2 className="hp-h2">Přehled bez chaosu.</h2>
                    <p className="hp-sub">
                        Data bez interpretace nemají hodnotu. Každý měsíc dostanete přehledný report se srozumitelným komentářem — ne tabulku čísel, ale odpovědi na otázku: co funguje a co je příštím krokem.
                    </p>
                    <div className="audit-list">
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Měsíční souhrnné reporty</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Jasně interpretovaná data</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Přehled KPI vůči cílům</p></div>
                        <div className="audit-item"><span className="hp-badge-blue dot" style={{ width: '6px', height: '6px' }}></span><p className="audit-item-text">Doporučení dalších kroků</p></div>
                    </div>
                </div>
                <div className="rep-right">
                    <img src={dashboardMockup} alt="Reporting dashboard" className="rep-mockup" />
                </div>
            </section>

            <section className="web-cta-section">
                <h2 className="hp-h2" style={{ color: '#FFF', fontSize: '44px', maxWidth: '760px' }}>Výkon bez řízení je jen utrácení.</h2>
                <p className="hp-sub" style={{ color: 'rgba(255, 255, 255, 0.8)', maxWidth: '560px' }}>
                    Začněme auditem — zjistíme, co funguje, co brzdí a kde je prostor pro růst.
                </p>
                <a href="https://cal.eu/andrea-liskova/30min" target="_blank" rel="noopener noreferrer" className="btn btn-white" style={{ marginTop: '12px' }}>
                    Domluvit strategický call
                </a>
            </section>
        </div>
    );
}

export default Vykon;
